<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :okText="this.$store.getters.language['common.okButton']"
    :ok-disabled="disableSubmit"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <sys-bm-application-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit"></sys-bm-application-form>
  </j-modal>
</template>

<script>

  import SysBmApplicationForm from './SysBmApplicationForm'

  export default {
    name: 'SysBmApplicationModal',
    components: {
      SysBmApplicationForm
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: false
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      add() {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.add();
        })
      },
      edit(record) {
        this.visible = true
        this.$nextTick(() => {
          this.$refs.realForm.edit(record);
        })
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleOk() {
        this.$refs.realForm.submitForm();
      },
      submitCallback() {
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      }
    }
  }
</script>